import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="maintenance-page">
          <div className="maintenance-card-box highlight-box-orange">
            <h1 className="titolo-principale">Qualcosa è andato storto</h1>
            <p className="testo-info">
              Si è verificato un errore tecnico imprevisto. I nostri sviluppatori sono già al lavoro!
            </p>
            <button 
              className="btn-custom-orange" 
              onClick={() => window.location.href = '/'}
            >
              Ricarica il sito
            </button>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;